import { useTranslation } from "react-i18next";
import useClientConfig from "../../common/hooks/clientConfigHook";
import Select from "../../common/components/Select";
import { useMemo } from "react";

const TaskbarDropdown = ({ ...props }) => {
    const { t } = useTranslation();
    const clientConfig = useClientConfig();

    const taskbars = useMemo(() => [{ label: t('none'), value: '' }, ...(clientConfig.desktop?.taskbars?.map(bar => ({ label: bar.name, value: bar.id })) ?? [])], [t, clientConfig.desktop?.taskbars]);

    return <Select options={taskbars} labelField="label" valueField="value" placeholder={t('taskbar')} {...props}></Select>
}

export default TaskbarDropdown;